import React, { Component } from "react";
import "../../../Containers/App.css";

import ProductListingPage from "../../ProductListingPage/ProductListingPage";
import Footer from "../../Footer/Footer";
import axios from "axios";
import { withRouter } from "react-router";

import { Container, Col, Row } from "react-bootstrap";

class ProductListingPageContainer extends Component {
  state = { products: [] };

  componentDidMount() {
    const { match } = this.props;
    let category = match.params.category;
    if (category === null || category === "" || category === undefined) {
      category = "mobiles";
    }

    axios
      .get("https://api.shopmuthu.com/category/" + category)
      .then((response) => {
        console.log(response);
        this.setState({ products: response.data });
      });
  }

  /*fetchProducts = async () => {
      const response = await fetch('http://localhost:3002/products');
      const responseData =  await response.json();
      const serverProducts=responseData.products;
      console.log("responseData: "+serverProducts);
      this.setState({products:serverProducts});

  }*/

  toggleProduct = () => {
    const doesShow = this.state.showProduct;
    this.setState({ showProduct: !doesShow });
  };

  showProductDisplayPage = () => {};

  render() {
    let product = null;

    // if(this.state.showProduct){
    //this.fetchProducts();
    const { match } = this.props;
    const category = match.params.category;
    product = (
      <Row>
        {this.state.products.map((product, index) => {
          return (
            <ProductListingPage
              click={() => this.showProductDisplayPage(index)}
              product={product}
              key={product.productName}
            />
          );
        })}
      </Row>
    );
    //}

    return (
      <Container>
        <Row>
          <Col className="col-md-12">
            <nav>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>

                <li className="breadcrumb-item active">{category}</li>
              </ol>
            </nav>
          </Col>
        </Row>

        {product}

        <Footer />
      </Container>
    );
  }
}

export default withRouter(ProductListingPageContainer);
